/**
 * @generated SignedSource<<da2b9592c12388a6c7264ffb97c9b1f7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CheckoutBankAccountList_transaction$data = {
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccount_transaction">;
  readonly " $fragmentType": "CheckoutBankAccountList_transaction";
};
export type CheckoutBankAccountList_transaction$key = {
  readonly " $data"?: CheckoutBankAccountList_transaction$data;
  readonly " $fragmentSpreads": FragmentRefs<"CheckoutBankAccountList_transaction">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CheckoutBankAccountList_transaction",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CheckoutBankAccount_transaction"
    }
  ],
  "type": "Transaction",
  "abstractKey": null
};

(node as any).hash = "28f449ea524942952512832e6301d437";

export default node;
